module.exports = __webpack_public_path__ + "img/high-charging-start.1a1286b4.png";